import React, { useMemo, useState } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps, MeteorData } from '../types'

export const MeteorsEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#ffffff'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const [meteors] = useState(() => {
    const newMeteors: Array<MeteorData> = []
    for (let i = 0; i < 20; i++) {
      newMeteors.push({
        id: i,
        x: Math.random() * 70 - 10,
        delay: Math.random() * 5,
        duration: 2 + Math.random() * 2,
      })
    }
    return newMeteors
  })

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        overflow: 'hidden',
        backgroundColor: effectBackgroundColor,
      }}
    >
      {meteors.map((meteor) => (
        <motion.div
          key={meteor.id}
          style={{
            position: 'absolute',
          }}
          initial={{
            left: `${meteor.x}%`,
            top: '-10%',
          }}
          animate={{
            left: `${meteor.x + 40}%`,
            top: '110%',
            opacity: [0, opacityValue, opacityValue, 0],
          }}
          transition={{
            duration: meteor.duration * (100 / Math.max(effectSpeed, 1)),
            repeat: Infinity,
            ease: 'linear',
            delay: meteor.delay,
            repeatDelay: Math.random() * 2,
          }}
        >
          <div
            style={{
              width: '4px',
              height: '80px',
              background: `linear-gradient(45deg, ${effectColors[0] || '#ffffff'}, transparent)`,
              boxShadow: `0 0 8px ${effectColors[0] || '#ffffff'}`,
              borderRadius: '2px',
            }}
          />
        </motion.div>
      ))}
    </div>
  )
})
MeteorsEffect.displayName = 'MeteorsEffect'
